import { render } from "./BaseIcon.vue?vue&type=template&id=69b883bc"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/components/BaseIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69b883bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69b883bc', __exports__)) {
    api.reload('69b883bc', __exports__)
  }
  
  module.hot.accept("./BaseIcon.vue?vue&type=template&id=69b883bc", () => {
    api.rerender('69b883bc', render)
  })

}


export default __exports__